import uuid from "../../../../utils/uuid.js"

export default function () {
  return {
    "content_ref": {},
    "blocks": [
      {
        "id": uuid(),
        "name": "",
        "position": {
          "x": 300,
          "y": 900
        },
        "animations": [
          {
            "trigger": "auto",
            "name": "none",
            "duration": 1,
            "delay": 0
          }
        ],
        "has_activity": false,
        "size": {
          "width": 800,
          "height": 180
        },
        "protection": {
          "type": [
            "textarea"
          ],
          "data": false,
          "move": false,
          "resize": false,
          "delete": false
        },
        "data": {
          "html": "<p><span class=\"fields\">{{LibraryContentTitle}}</span></p>",
          "fontSize": 60,
          "color": "#000000ff",
          "textAlign": "center",
          "alignItems": "center",
          "fontFamily": false,
          "padding": 0
        },
        "type": "textarea"
      },
      {
        "id": uuid(),
        "name": "",
        "position": {
          "x": 0,
          "y": 0
        },
        "animations": [
          {
            "trigger": "auto",
            "name": "none",
            "duration": 1,
            "delay": 0
          }
        ],
        "has_activity": false,
        "size": {
          "width": 1920,
          "height": 900
        },
        "protection": {
          "type": [
            "textarea"
          ],
          "data": false,
          "move": false,
          "resize": false,
          "delete": false
        },
        "data": {
          "content_ref": {},
          "pinned_view": {}
        },
        "type": "libraryContent"
      },
      {
        "id": uuid(),
        "name": "",
        "position": {
          "x": 1100,
          "y": 935
        },
        "animations": [
          {
            "trigger": "auto",
            "name": "none",
            "duration": 1,
            "delay": 0
          }
        ],
        "has_activity": false,
        "size": {
          "width": 200,
          "height": 100
        },
        "protection": {
          "type": [
            "button"
          ],
          "data": false,
          "move": false,
          "resize": false,
          "delete": false
        },
        "data": {
          "text": "Expand",
          "icon": "none",
          "visited": false,
          "style": {
            "regular": {
              "backgroundColor": "#f5f5f5ff",
              "color": "#000000ff",
              "textScale": 100,
              "textAlign": "center",
              "boxShadowButton": "none",
              "borderRadius": 0,
              "fontFamily": false
            },
            "hover": {
              "backgroundColor": "#e0e0e0ff",
              "color": "#000000ff",
              "textScale": 100,
              "textAlign": "center",
              "boxShadowButton": "none",
              "borderRadius": 0,
              "fontFamily": false
            },
            "active": {
              "backgroundColor": "#bdbdbdff",
              "color": "#000000ff",
              "textScale": 100,
              "textAlign": "center",
              "boxShadowButton": "none",
              "borderRadius": 0,
              "fontFamily": false
            },
            "visited": {
              "backgroundColor": "#bdbdbdff",
              "color": "#000000ff",
              "textScale": 100,
              "textAlign": "center",
              "boxShadowButton": "none",
              "borderRadius": 0,
              "fontFamily": false
            }
          },
          "actions": [
            {
              "trigger": "click",
              "type": "event",
              "event": "submit"
            }
          ]
        },
        "type": "button"
      }
    ],
    "overlays": {
      "expanded": {
        "id": uuid(),
        "width": 1920,
        "height": 1024,
        "style": {
          "backgroundColor": "#ffffffff",
          "borderRadius": 0
        },
        "blocks": [
          {
            "id": uuid(),
            "name": "",
            "position": {
              "x": 0,
              "y": 40
            },
            "animations": [
              {
                "trigger": "auto",
                "name": "none",
                "duration": 1,
                "delay": 0
              }
            ],
            "has_activity": false,
            "size": {
              "width": 1920,
              "height": 60
            },
            "protection": {
              "type": [
                "textarea"
              ],
              "data": false,
              "move": false,
              "resize": false,
              "delete": false
            },
            "data": {
              "html": "<p><span class=\"fields\">{{LibraryContentId}}</span></p>",
              "fontSize": 30,
              "color": "#000000ff",
              "textAlign": "center",
              "alignItems": "flex-start",
              "fontFamily": false,
              "padding": 0
            },
            "type": "textarea"
          },
          {
            "id": uuid(),
            "name": "",
            "position": {
              "x": 0,
              "y": 0
            },
            "animations": [
              {
                "trigger": "auto",
                "name": "none",
                "duration": 1,
                "delay": 0
              }
            ],
            "has_activity": false,
            "size": {
              "width": 1920,
              "height": 900
            },
            "protection": {
              "type": [
                "textarea"
              ],
              "data": false,
              "move": false,
              "resize": false,
              "delete": false
            },
            "data": {
              "content_ref": {},
              "pinned_view": {}
            },
            "type": "libraryContent"
          }
        ]
      }
    }
  }
}
